// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preWorkDaliyCheckUser {\n  min-width: 150px;\n  max-width: 250px;\n  padding-bottom: 0px !important;\n}\n.preWorkDaliyCheckUser .q-field {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
